import React from 'react';
import * as RadixSelect from '@radix-ui/react-select';
import classNames from 'classnames';

import styles from './MultiSelectItem.module.scss';

export interface IMultiSelectItemProps extends Omit<RadixSelect.SelectItemProps, 'onSelect'> {
    selected?: boolean;
}

export const MultiSelectItem: React.FC<IMultiSelectItemProps> = ({ children, className, selected, ...props }) => {
    return (
        <RadixSelect.Item
            className={classNames(styles.selectItem, className)}
            {...props}
            data-state={selected ? 'checked' : 'unchecked'}
        >
            <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
        </RadixSelect.Item>
    );
};
